import { RouteRecordRaw } from "vue-router";
import { AuthRouteNames } from "@/constants/routes";

const authRoutes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: AuthRouteNames.LOGIN,
        component: () => import("@/views/auth/login/StandardLogin.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
    {
        path: "/login-sso",
        name: AuthRouteNames.SSO_LOGIN,
        component: () => import("@/views/auth/login/SsoLogin.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
    {
        path: "/sso/redirect-sign-in",
        name: AuthRouteNames.SSO_SIGN_IN_REDIRECT,
        component: () => import("@/views/auth/login/SsoSignInRedirect.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
    {
        path: "/sso/redirect-sign-out",
        name: AuthRouteNames.SSO_SIGN_OUT_REDIRECT,
        component: () => import("@/views/auth/login/SsoSignOutRedirect.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
    {
        path: "/unauthorised-access",
        name: AuthRouteNames.UNAUTHORISED_ACCESS,
        component: () => import("@/views/auth/UnauthorisedAccess.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
    {
        path: "/:catchAll(.*)",
        name: AuthRouteNames.NOT_FOUND,
        component: () => import("@/views/auth/404.vue"),
        meta: {
            requiredPermissions: [],
        },
    },
];

export default authRoutes.map((route) => {
    return { ...route };
});
